var pe = Object.defineProperty;
var W = (t) => {
  throw TypeError(t);
};
var me = (t, e, n) => e in t ? pe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var m = (t, e, n) => me(t, typeof e != "symbol" ? e + "" : e, n), ge = (t, e, n) => e.has(t) || W("Cannot " + n);
var H = (t, e, n) => e.has(t) ? W("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n);
var h = (t, e, n) => (ge(t, e, "access private method"), n);
import { uid as ve } from "uid";
var x, J, B, I = function() {
  var t = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, Te = function(t) {
  if (document.readyState === "loading") return "loading";
  var e = I();
  if (e) {
    if (t < e.domInteractive) return "loading";
    if (e.domContentLoadedEventStart === 0 || t < e.domContentLoadedEventStart) return "dom-interactive";
    if (e.domComplete === 0 || t < e.domComplete) return "dom-content-loaded";
  }
  return "complete";
}, ye = function(t) {
  var e = t.nodeName;
  return t.nodeType === 1 ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
}, $ = function(t, e) {
  var n = "";
  try {
    for (; t && t.nodeType !== 9; ) {
      var i = t, r = i.id ? "#" + i.id : ye(i) + (i.classList && i.classList.value && i.classList.value.trim() && i.classList.value.trim().length ? "." + i.classList.value.trim().replace(/\s+/g, ".") : "");
      if (n.length + r.length > (e || 100) - 1) return n || r;
      if (n = n ? r + ">" + n : r, i.id) break;
      t = i.parentNode;
    }
  } catch {
  }
  return n;
}, ee = -1, be = function() {
  return ee;
}, R = function(t) {
  addEventListener("pageshow", function(e) {
    e.persisted && (ee = e.timeStamp, t(e));
  }, !0);
}, V = function() {
  var t = I();
  return t && t.activationStart || 0;
}, w = function(t, e) {
  var n = I(), i = "navigate";
  return be() >= 0 ? i = "back-forward-cache" : n && (document.prerendering || V() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : n.type && (i = n.type.replace(/_/g, "-"))), { name: t, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: i };
}, k = function(t, e, n) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      var i = new PerformanceObserver(function(r) {
        Promise.resolve().then(function() {
          e(r.getEntries());
        });
      });
      return i.observe(Object.assign({ type: t, buffered: !0 }, n || {})), i;
    }
  } catch {
  }
}, S = function(t, e, n, i) {
  var r, a;
  return function(o) {
    e.value >= 0 && (o || i) && ((a = e.value - (r || 0)) || r === void 0) && (r = e.value, e.delta = a, e.rating = function(u, s) {
      return u > s[1] ? "poor" : u > s[0] ? "needs-improvement" : "good";
    }(e.value, n), t(e));
  };
}, Ee = function(t) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return t();
    });
  });
}, j = function(t) {
  document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && t();
  });
}, te = function(t) {
  var e = !1;
  return function() {
    e || (t(), e = !0);
  };
}, y = -1, K = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, F = function(t) {
  document.visibilityState === "hidden" && y > -1 && (y = t.type === "visibilitychange" ? t.timeStamp : 0, we());
}, G = function() {
  addEventListener("visibilitychange", F, !0), addEventListener("prerenderingchange", F, !0);
}, we = function() {
  removeEventListener("visibilitychange", F, !0), removeEventListener("prerenderingchange", F, !0);
}, Se = function() {
  return y < 0 && (y = K(), G(), R(function() {
    setTimeout(function() {
      y = K(), G();
    }, 0);
  })), { get firstHiddenTime() {
    return y;
  } };
}, Q = function(t) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return t();
  }, !0) : t();
}, ne = 0, P = 1 / 0, D = 0, Me = function(t) {
  t.forEach(function(e) {
    e.interactionId && (P = Math.min(P, e.interactionId), D = Math.max(D, e.interactionId), ne = D ? (D - P) / 7 + 1 : 0);
  });
}, Ie = function() {
  "interactionCount" in performance || x || (x = k("event", Me, { type: "event", buffered: !0, durationThreshold: 0 }));
}, p = [], M = /* @__PURE__ */ new Map(), ie = 0, Le = function() {
  return (x ? ne : performance.interactionCount || 0) - ie;
}, re = [], De = function(t) {
  if (re.forEach(function(r) {
    return r(t);
  }), t.interactionId || t.entryType === "first-input") {
    var e = p[p.length - 1], n = M.get(t.interactionId);
    if (n || p.length < 10 || t.duration > e.latency) {
      if (n) t.duration > n.latency ? (n.entries = [t], n.latency = t.duration) : t.duration === n.latency && t.startTime === n.entries[0].startTime && n.entries.push(t);
      else {
        var i = { id: t.interactionId, latency: t.duration, entries: [t] };
        M.set(i.id, i), p.push(i);
      }
      p.sort(function(r, a) {
        return a.latency - r.latency;
      }), p.length > 10 && p.splice(10).forEach(function(r) {
        return M.delete(r.id);
      });
    }
  }
}, z = function(t) {
  var e = self.requestIdleCallback || self.setTimeout, n = -1;
  return t = te(t), document.visibilityState === "hidden" ? t() : (n = e(t), j(t)), n;
}, X = [200, 500], Ce = function(t, e) {
  "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (e = e || {}, Q(function() {
    var n;
    Ie();
    var i, r = w("INP"), a = function(u) {
      z(function() {
        u.forEach(De);
        var s, d = (s = Math.min(p.length - 1, Math.floor(Le() / 50)), p[s]);
        d && d.latency !== r.value && (r.value = d.latency, r.entries = d.entries, i());
      });
    }, o = k("event", a, { durationThreshold: (n = e.durationThreshold) !== null && n !== void 0 ? n : 40 });
    i = S(t, r, X, e.reportAllChanges), o && (o.observe({ type: "first-input", buffered: !0 }), j(function() {
      a(o.takeRecords()), i(!0);
    }), R(function() {
      ie = 0, p.length = 0, M.clear(), r = w("INP"), i = S(t, r, X, e.reportAllChanges);
    }));
  }));
}, b = [], g = [], U = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new Map(), q = -1, Fe = function(t) {
  b = b.concat(t), ae();
}, ae = function() {
  q < 0 && (q = z(Re));
}, Re = function() {
  E.size > 10 && E.forEach(function(u, s) {
    M.has(s) || E.delete(s);
  });
  var t = p.map(function(u) {
    return U.get(u.entries[0]);
  }), e = g.length - 50;
  g = g.filter(function(u, s) {
    return s >= e || t.includes(u);
  });
  for (var n = /* @__PURE__ */ new Set(), i = 0; i < g.length; i++) {
    var r = g[i];
    oe(r.startTime, r.processingEnd).forEach(function(u) {
      n.add(u);
    });
  }
  for (var a = 0; a < 50; a++) {
    var o = b[b.length - 1 - a];
    if (!o || o.startTime < B) break;
    n.add(o);
  }
  b = Array.from(n), q = -1;
};
re.push(function(t) {
  t.interactionId && t.target && !E.has(t.interactionId) && E.set(t.interactionId, t.target);
}, function(t) {
  var e, n = t.startTime + t.duration;
  B = Math.max(B, t.processingEnd);
  for (var i = g.length - 1; i >= 0; i--) {
    var r = g[i];
    if (Math.abs(n - r.renderTime) <= 8) {
      (e = r).startTime = Math.min(t.startTime, e.startTime), e.processingStart = Math.min(t.processingStart, e.processingStart), e.processingEnd = Math.max(t.processingEnd, e.processingEnd), e.entries.push(t);
      break;
    }
  }
  e || (e = { startTime: t.startTime, processingStart: t.processingStart, processingEnd: t.processingEnd, renderTime: n, entries: [t] }, g.push(e)), (t.interactionId || t.entryType === "first-input") && U.set(t, e), ae();
});
var oe = function(t, e) {
  for (var n, i = [], r = 0; n = b[r]; r++) if (!(n.startTime + n.duration < t)) {
    if (n.startTime > e) break;
    i.push(n);
  }
  return i;
}, ke = function(t, e) {
  J || (J = k("long-animation-frame", Fe)), Ce(function(n) {
    var i = function(r) {
      var a = r.entries[0], o = U.get(a), u = a.processingStart, s = o.processingEnd, d = o.entries.sort(function(T, he) {
        return T.processingStart - he.processingStart;
      }), l = oe(a.startTime, s), f = r.entries.find(function(T) {
        return T.target;
      }), v = f && f.target || E.get(a.interactionId), A = [a.startTime + a.duration, s].concat(l.map(function(T) {
        return T.startTime + T.duration;
      })), L = Math.max.apply(Math, A), fe = { interactionTarget: $(v), interactionTargetElement: v, interactionType: a.name.startsWith("key") ? "keyboard" : "pointer", interactionTime: a.startTime, nextPaintTime: L, processedEventEntries: d, longAnimationFrameEntries: l, inputDelay: u - a.startTime, processingDuration: s - u, presentationDelay: Math.max(L - s, 0), loadState: Te(a.startTime) };
      return Object.assign(r, { attribution: fe });
    }(n);
    t(i);
  }, e);
}, Y = [2500, 4e3], _ = {}, Ae = function(t, e) {
  (function(n, i) {
    i = i || {}, Q(function() {
      var r, a = Se(), o = w("LCP"), u = function(l) {
        i.reportAllChanges || (l = l.slice(-1)), l.forEach(function(f) {
          f.startTime < a.firstHiddenTime && (o.value = Math.max(f.startTime - V(), 0), o.entries = [f], r());
        });
      }, s = k("largest-contentful-paint", u);
      if (s) {
        r = S(n, o, Y, i.reportAllChanges);
        var d = te(function() {
          _[o.id] || (u(s.takeRecords()), s.disconnect(), _[o.id] = !0, r(!0));
        });
        ["keydown", "click"].forEach(function(l) {
          addEventListener(l, function() {
            return z(d);
          }, !0);
        }), j(d), R(function(l) {
          o = w("LCP"), r = S(n, o, Y, i.reportAllChanges), Ee(function() {
            o.value = performance.now() - l.timeStamp, _[o.id] = !0, r(!0);
          });
        });
      }
    });
  })(function(n) {
    var i = function(r) {
      var a = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadDuration: 0, elementRenderDelay: r.value };
      if (r.entries.length) {
        var o = I();
        if (o) {
          var u = o.activationStart || 0, s = r.entries[r.entries.length - 1], d = s.url && performance.getEntriesByType("resource").filter(function(L) {
            return L.name === s.url;
          })[0], l = Math.max(0, o.responseStart - u), f = Math.max(l, d ? (d.requestStart || d.startTime) - u : 0), v = Math.max(f, d ? d.responseEnd - u : 0), A = Math.max(v, s.startTime - u);
          a = { element: $(s.element), timeToFirstByte: l, resourceLoadDelay: f - l, resourceLoadDuration: v - f, elementRenderDelay: A - v, navigationEntry: o, lcpEntry: s }, s.url && (a.url = s.url), d && (a.lcpResourceEntry = d);
        }
      }
      return Object.assign(r, { attribution: a });
    }(n);
    t(i);
  }, e);
}, Z = [800, 1800], Pe = function t(e) {
  document.prerendering ? Q(function() {
    return t(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return t(e);
  }, !0) : setTimeout(e, 0);
}, _e = function(t, e) {
  e = e || {};
  var n = w("TTFB"), i = S(t, n, Z, e.reportAllChanges);
  Pe(function() {
    var r = I();
    r && (n.value = Math.max(r.responseStart - V(), 0), n.entries = [r], i(!0), R(function() {
      n = w("TTFB", 0), (i = S(t, n, Z, e.reportAllChanges))(!0);
    }));
  });
}, xe = function(t, e) {
  _e(function(n) {
    var i = function(r) {
      var a = { waitingDuration: 0, cacheDuration: 0, dnsDuration: 0, connectionDuration: 0, requestDuration: 0 };
      if (r.entries.length) {
        var o = r.entries[0], u = o.activationStart || 0, s = Math.max((o.workerStart || o.fetchStart) - u, 0), d = Math.max(o.domainLookupStart - u, 0), l = Math.max(o.connectStart - u, 0), f = Math.max(o.connectEnd - u, 0);
        a = { waitingDuration: s, cacheDuration: d - s, dnsDuration: l - d, connectionDuration: f - l, requestDuration: r.value - f, navigationEntry: o };
      }
      return Object.assign(r, { attribution: a });
    }(n);
    t(i);
  }, e);
}, c, N, se, ue, ce, O, C, de, le;
class Ne {
  constructor(e) {
    H(this, c);
    m(this, "resourceMonitoringResultsToSend");
    m(this, "timeoutId");
    m(this, "requestThrottleMs");
    m(this, "sending");
    m(this, "sentResults");
    m(this, "webVitalsQueue");
    m(this, "resourcesEndpoint");
    m(this, "webVitalsEndpoint");
    this.appId = e.appId, this.enabledFeatures = (e == null ? void 0 : e.enabledFeatures) || {}, this.domainName = (e == null ? void 0 : e.domainName) || window.location.hostname, this.webVitalsQueue = /* @__PURE__ */ new Set(), this.resourcesEndpoint = "/resources/add", this.webVitalsEndpoint = "/web-vitals/add", this._apiEndpoint = "https://api.perforgo.com/api/app/" + this.appId + "/analytics", this.resourceMonitoringResultsToSend = [], this.timeoutId = null, this.requestThrottleMs = 3e3, this.sending = !1, this.sentResults = [];
  }
  init() {
    if (!this.appId) {
      console.error(
        "You need to specify a Perforgo App ID. Analytics reporting is disabled."
      );
      return;
    }
    if (this.enabledFeatures.lcp && Ae(
      (e) => {
        var n, i;
        return h(this, c, C).call(this, e, {
          hostname: (n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname,
          page_path: (i = window == null ? void 0 : window.location) == null ? void 0 : i.pathname
        });
      }
    ), this.enabledFeatures.fcp, (this.enabledFeatures.inp || this.enabledFeatures.fid) && ke(
      (e) => {
        var n, i;
        h(this, c, C).call(this, e, {
          hostname: (n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname,
          page_path: (i = window == null ? void 0 : window.location) == null ? void 0 : i.pathname
        });
      },
      { reportAllChanges: !0 }
    ), this.enabledFeatures.ttfb && xe(
      (e) => {
        var n, i;
        return h(this, c, C).call(this, e, {
          hostname: (n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname,
          page_path: (i = window == null ? void 0 : window.location) == null ? void 0 : i.pathname
        });
      }
    ), this.enabledFeatures.resourceMonitoring) {
      const e = new PerformanceObserver((i) => {
        i.getEntries().forEach((r) => {
          if (r.entryType === "resource") {
            const a = r;
            h(this, c, O).call(this, a);
          }
        });
      });
      e.observe({ type: "resource", buffered: !0 }), e.takeRecords().forEach((i) => {
        if (i.entryType === "resource") {
          const r = i;
          h(this, c, O).call(this, r);
        }
      }), this.timeoutId = setTimeout(
        async () => await h(this, c, N).call(this, this.resourceMonitoringResultsToSend),
        this.requestThrottleMs
      );
    }
    addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && h(this, c, le).call(this);
    });
  }
  get apiEndpoint() {
    return this._apiEndpoint;
  }
}
c = new WeakSet(), N = async function(e) {
  let n = [], i = null;
  if (e.length && (n = e.filter((r) => !(this.sentResults.findIndex(
    (a) => a.perforgo_resource_id === r.perforgo_resource_id
  ) >= 0)), !!n.length && (i = JSON.stringify(n), !this.sending))) {
    this.sending = !0;
    try {
      await fetch(this.apiEndpoint + this.resourcesEndpoint, {
        body: i,
        method: "POST",
        keepalive: !0,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }), this.sentResults.push(...n), this.sending = !1;
    } catch (r) {
      console.log(r);
    }
  }
}, se = function() {
  this.timeoutId && clearTimeout(this.timeoutId), this.timeoutId = setTimeout(
    async () => await h(this, c, N).call(this, this.resourceMonitoringResultsToSend),
    this.requestThrottleMs
  );
}, ue = function(e) {
  return e;
}, ce = function(e) {
  var n, i, r;
  return (i = (n = this.enabledFeatures.resourceMonitoring) == null ? void 0 : n.excludedDomains) != null && i.length ? ((r = this.enabledFeatures.resourceMonitoring) == null ? void 0 : r.excludedDomains.filter(
    (a) => a.matchType === "includes" ? !e.includes(a.domainName) : a.domainName !== e
  ).length) > 0 : !0;
}, O = function(e) {
  var n, i;
  h(this, c, se).call(this), !(e.transferSize === 0 && e.decodedBodySize > 0) && (i = (n = this.enabledFeatures) == null ? void 0 : n.resourceMonitoring) != null && i.images && e.initiatorType === "img" && h(this, c, ce).call(this, new URL(e.name).hostname) && this.resourceMonitoringResultsToSend.push({
    perforgo_resource_id: ve(),
    resource_domain: new URL(e.name).hostname,
    resource_path: new URL(e.name).pathname,
    hostname: this.domainName,
    type: e.initiatorType,
    transfer_size: h(this, c, ue).call(this, e.transferSize),
    page_path: window.location.pathname
  });
}, C = function(e, n) {
  this.webVitalsQueue.add({
    ...e,
    ...n
  });
}, de = function(e) {
  const n = {
    id: e.id,
    name: e.name,
    value: e.value,
    delta: e.delta,
    rating: e.rating,
    hostname: e.hostname,
    page_path: e.page_path
  };
  return e.name === "LCP" ? {
    ...n,
    navigationType: e.navigationType,
    attribution: {
      timeToFirstByte: e.attribution.timeToFirstByte
    },
    entries: e.entries.map((i) => ({
      loadTime: i.loadTime,
      renderTime: i.renderTime,
      startTime: i.startTime,
      entryType: i.entryType
    }))
  } : e.name === "TTFB" ? {
    ...n,
    navigationType: e.navigationType,
    attribution: {
      requestDuration: e.attribution.requestDuration
    }
  } : e.name === "INP" ? {
    ...n,
    interactionType: e.attribution.interactionType
  } : {
    ...n,
    ...e
  };
}, le = function() {
  if (this.webVitalsQueue.size > 0) {
    const e = JSON.stringify(
      Array.from(this.webVitalsQueue).flatMap(h(this, c, de))
    );
    navigator.sendBeacon && navigator.sendBeacon(
      this.apiEndpoint + this.webVitalsEndpoint,
      new Blob([e], { type: "application/json" })
    ) || fetch(this.apiEndpoint + this.webVitalsEndpoint, {
      body: e,
      method: "POST",
      keepalive: !0,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }), this.webVitalsQueue.clear();
  }
};
export {
  Ne as Perforgo
};
